export default function responseHandler(err) {
  return new Promise((resolve, reject) => {
    const authEndpoints = ["/api/otp", "/api/login"];
    const requestUrl = err.config?.url;
    const isAuthRequest = authEndpoints.some(
      (endpoint) =>
        requestUrl === endpoint ||
        requestUrl?.startsWith(`${endpoint}?`) ||
        requestUrl?.endsWith(endpoint),
    );
    const currentToken = window.localStorage.getItem("jwt");
    const requestToken = err.config?.authTokenAtRequest;
    const isCurrentAuthRequest = requestToken && requestToken === currentToken;

    if (
      typeof err.response !== "undefined" &&
      typeof err.response.status !== "undefined" &&
      err.response.status == 401 &&
      !isAuthRequest &&
      isCurrentAuthRequest
    ) {
      window.localStorage.removeItem("jwt");
      window.location.href = "/";
      return reject(err);
    }

    return reject(err);
  });
}
